// SDEV-FILE
// Copyright (c) 2026 SDEV. All rights reserved.
// Workspace: clientside
// File: api.discovery.js
// Created: 2026-03-13T17:46:33.076Z

import api from "@/domain/api/api.client"
import { apiPost } from "@/domain/api/api.request"
import { getIdentityId } from "@/domain/auth/auth.service"

export async function wizardSessions() {
    const identityId = getIdentityId()

    const res = await api.get(`/api/wizard/sessions/${identityId}`)
    return res.data
}
export async function discoveryBlueprint() {

}
export async function discoveryRuns() {

}
export async function discoveryScan() {


}


export async function discoveryStart() {

}

export async function discoveryStep() {

}